module.exports = __webpack_public_path__ + "img/서브_배려심.09ea118a.svg";